import React, { FC } from 'react';
import Image from 'next/image';
import { useMatchMedia } from '~/src/hooks/use-match-media.hook';
import { IMAGE_QUALITY } from '~/src/models/constants/image-quality.constants';
import SocketImage from '~/src/images/page-not-load/socket.png';
import { MediaWidthEnum } from '~/src/models/enums/media-width.enum';
import * as Styled from './page-not-load.styles';

const PageNotLoad: FC = () => {
    const [isMobile] = useMatchMedia(MediaWidthEnum.mobile, { withoutSSR: true });

    return (
        <Styled.PageNotLoadContainer>
            <Styled.ContentWrapper>
                <Image
                    src={SocketImage}
                    width={isMobile ? 183 : 296}
                    height={isMobile ? 109 : 172}
                    alt={'Что-то не загружается'}
                    quality={IMAGE_QUALITY.VERY_HIGH}
                />
                <Styled.TextContainer>
                    <Styled.TitleNotLoad>Что-то не загружается</Styled.TitleNotLoad>
                    <Styled.SubText>Обновите страницу позже</Styled.SubText>
                </Styled.TextContainer>
            </Styled.ContentWrapper>
        </Styled.PageNotLoadContainer>
    );
};

export default PageNotLoad;
